import { useState, useEffect, useMemo } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import { useLiveQuery } from "dexie-react-hooks";

const useGrupoCentralizador = (formikRef, name = 'grupoCentralizadorId', config = {}) => {
  const grupoCentralizadorSelect = useSelect("grupoCentralizador");
  const [fila, setFila] = useState(null);
  const { trilhaId } = config;

  const liveGruposCentralizadores = useLiveQuery(async () => {
    const hasTrilhaIndex = Boolean(
      db?.grupoCentralizador?.schema?.idxByName?.trilhaId ||
      db?.grupoCentralizador?.schema?.indexes?.some((idx) => idx.name === "trilhaId")
    );

    try {
      if (trilhaId && hasTrilhaIndex) {
        return await db.grupoCentralizador
          .where("trilhaId")
          .equals(trilhaId)
          .filter((a) => a.ativo)
          .toArray();
      }

      if (trilhaId) {
        const all = await db.grupoCentralizador.filter((a) => a.ativo).toArray();
        return (all || []).filter((g) => String(g.trilhaId) === String(trilhaId));
      }

      return await db.grupoCentralizador.filter((a) => a.ativo).toArray();
    } catch (err) {
      const all = await db.grupoCentralizador.toArray();
      return (all || []).filter((g) => g.ativo && (!trilhaId || String(g.trilhaId) === String(trilhaId)));
    }
  }, [trilhaId]);

  const gruposCentralizadores = useMemo(
    () => liveGruposCentralizadores || [],
    [liveGruposCentralizadores]
  );


  const gruposCentralizadoresFiltrados = useMemo(() => gruposCentralizadores || [], [gruposCentralizadores]);

  const optionGruposCentralizadores = useMemo(
    () => prepareForOptions(gruposCentralizadoresFiltrados, ['codigo', 'nome'], 'id'),
    [gruposCentralizadoresFiltrados]
  );

  function onChangeGrupoCentralizador(e) {
    if (e?.value != undefined || !e) {
      grupoCentralizadorSelect.upDateValue(e?.value || "");
      grupoCentralizadorSelect.upDateDefaultValue(e || "");
      formikRef.current.setFieldValue(name, e?.value || "");
      setTimeout(() =>
        formikRef.current.setFieldTouched(name, true)
      );
    }
  }

  function SetSelectGrupoCentralizador(id) {
    if (optionGruposCentralizadores?.length) {
      const data = optionGruposCentralizadores.find((item) => item.value === id);
      if (data) {
        onChangeGrupoCentralizador(data)
      }
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionGruposCentralizadores?.length > 0) {
      SetSelectGrupoCentralizador(fila);
    } else if (fila === null) {
      if (formikRef.current.values?.grupoCentralizadorId !== 0 && formikRef.current.values?.grupoCentralizador !== '') {
        onChangeGrupoCentralizador({ label: `${formikRef.current.values?.grupoCentralizador}`, value: formikRef.current.values?.grupoCentralizadorId })
      }
    }
  }, [fila, optionGruposCentralizadores, formikRef])


  return {
    gruposCentralizadores,
    gruposCentralizadoresFiltrados,
    grupoCentralizadorSelect,
    onChangeGrupoCentralizador,
    SetSelectGrupoCentralizador,
    optionGruposCentralizadores
  };
}

export default useGrupoCentralizador;